import { useMemo, useState } from 'react';
import { Button, CircularProgress, Dialog } from '@mui/material';

import { Icon } from '../../shared/Icon';
import { GiftForm, GiftFormValue } from './GiftForm';

import { GameElementDto, useGameElements } from '../../hooks/gameElements';
import { useGiftAdmin } from '../../hooks/useGiftApi';

import { assert } from '../../utils/assert';

export const CreateGiftButton = () => {
    const gameElementsQuery = useGameElements();
    const gameElements = useMemo(() => {
        if (!gameElementsQuery.data) {
            return undefined;
        }
        return new Map<string, GameElementDto>(
            gameElementsQuery.data.gameElements.map((element) => [
                element.id,
                element,
            ]),
        );
    }, [gameElementsQuery.data]);

    const [isCreatingGift, setIsCreatingGift] = useState<boolean>(false);

    const { createGift } = useGiftAdmin();

    const saveGift = async (gift: GiftFormValue) => {
        const {
            name,
            contents,
            wrapperGameElementId,
            publication,
            tutorial = false,
            defaultClaimed = false,
            minimumVersion,
            jiraIssueKey,
        } = gift;
        assert(publication, 'publication is undefined');

        await createGift(
            gift.id,
            {
                name,
                contents,
                wrapperGameElementId,
                tutorial,
                defaultClaimed,
                minimumVersion: minimumVersion || null,
                jiraIssueKey: jiraIssueKey || null,
            },
            publication,
        );
    };

    return (
        <>
            <Dialog
                open={isCreatingGift}
                onClose={() => setIsCreatingGift(false)}
                maxWidth="sm"
                fullWidth
            >
                {gameElements !== undefined ? (
                    <GiftForm
                        gameElements={gameElements}
                        onSave={(gift) => {
                            setIsCreatingGift(false);
                            return saveGift(gift);
                        }}
                        onCancel={() =>
                            setIsCreatingGift((isCreating) => !isCreating)
                        }
                    />
                ) : (
                    <CircularProgress />
                )}
            </Dialog>
            <Button
                startIcon={<Icon name="add" />}
                onClick={(e) => {
                    e.stopPropagation();
                    setIsCreatingGift(true);
                }}
                variant="contained"
            >
                Add Gift
            </Button>
        </>
    );
};
